import { render, staticRenderFns } from "./inputDom.vue?vue&type=template&id=53e18d44"
import script from "./inputDom.vue?vue&type=script&lang=js"
export * from "./inputDom.vue?vue&type=script&lang=js"
import style0 from "./inputDom.vue?vue&type=style&index=0&id=53e18d44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports